<div class="auth-page-canvas">
  <div class="auth-card register-card glass-card">
    <div class="auth-brand-header">
      <div class="auth-logo-badge">
        <img
          src="/abaq.png"
          alt="Logo ABAQ Querétaro"
          class="auth-brand-img"
          style="width: 44px; height: 44px; object-fit: contain;"
          onerror="this.style.display='none'"
        />
        <div class="auth-brand-title-group">
          <span class="auth-brand-wordmark">ABAQ</span>
          <span class="auth-brand-dot" aria-hidden="true"></span>
        </div>
      </div>
      <span class="auth-brand-kicker">
        {{
          !userType
            ? 'REGISTRO DE VOLUNTARIO'
            : userType === 'VG'
              ? 'VOLUNTARIADO GENERAL (INDEPENDIENTE)'
              : 'SERVICIO SOCIAL (480 HORAS)'
        }}
      </span>
      <h1 class="auth-card-title">
        {{ !userType ? '¿Cómo te gustaría colaborar?' : 'Crear cuenta' }}
      </h1>
      <p class="auth-card-subtitle">
        {{
          !userType
            ? 'Selecciona tu tipo de participación antes de continuar con tu registro.'
            : userType === 'VG'
              ? 'Regístrate con tu correo personal para participar en eventos y actividades por amor a la causa.'
              : 'Regístrate con tu correo institucional para acreditar tus 480 horas curriculares.'
        }}
      </p>
    </div>

    <!-- Banner de alerta con lista específica de campos faltantes o con error -->
    @if (errorMsg || missingFieldsList.length > 0) {
      <div
        class="auth-alert-error"
        role="alert"
        style="flex-direction: column; align-items: flex-start; gap: 6px; background: #fef2f2; border: 1.5px solid #ef4444; color: #991b1b; padding: 12px 14px; border-radius: 12px; margin-bottom: 16px;"
      >
        <div style="display: flex; align-items: center; gap: 8px; font-weight: 800; font-size: 13px;">
          <span class="material-symbols-outlined" style="font-size: 18px; color: #dc2626;">error</span>
          <span>{{ errorMsg }}</span>
        </div>
        @if (missingFieldsList.length > 0) {
          <ul style="margin: 2px 0 0 22px; padding: 0; font-size: 12.5px; font-weight: 600; line-height: 1.5;">
            @for (item of missingFieldsList; track item) {
              <li>{{ item }}</li>
            }
          </ul>
        }
      </div>
    }

    <!-- PASO A: Tarjeta interactiva para elegir tipo (Estudiante SS vs Voluntario General VG) -->
    @if (!userType) {
      <div
        class="auth-type-picker-container"
        style="display: flex; flex-direction: column; gap: 0.85rem; margin-top: 0.5rem;"
        (keydown)="handleStepAKeyDown($event)"
      >
        <button
          #typeSsBtn
          type="button"
          id="select-type-ss"
          class="auth-type-card-btn"
          (click)="selectUserType('SS')"
          style="
            display: flex;
            align-items: center;
            gap: 0.9rem;
            padding: 0.95rem 1.15rem;
            border-radius: 14px;
            border: 2px solid rgba(36, 54, 111, 0.15);
            background: #ffffff;
            cursor: pointer;
            text-align: left;
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          "
        >
          <div
            style="
              width: 44px;
              height: 44px;
              border-radius: 12px;
              background: rgba(30, 58, 138, 0.1);
              color: #1e3a8a;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            "
          >
            <span class="material-symbols-outlined" style="font-size: 24px;">school</span>
          </div>
          <div style="flex: 1;">
            <strong style="display: block; font-size: 0.95rem; color: #1e293b; margin-bottom: 0.15rem;">
              Estudiante de Universidad / Servicio Social
            </strong>
            <span style="display: block; font-size: 0.8125rem; color: #64748b; line-height: 1.35;">
              Requiere validar sus 480 horas curriculares oficiales con su institución educativa.
            </span>
          </div>
          <span class="material-symbols-outlined" style="color: #94a3b8; font-size: 20px;">arrow_forward</span>
        </button>

        <button
          #typeVgBtn
          type="button"
          id="select-type-vg"
          class="auth-type-card-btn"
          (click)="selectUserType('VG')"
          style="
            display: flex;
            align-items: center;
            gap: 0.9rem;
            padding: 0.95rem 1.15rem;
            border-radius: 14px;
            border: 2px solid rgba(36, 54, 111, 0.15);
            background: #ffffff;
            cursor: pointer;
            text-align: left;
            transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          "
        >
          <div
            style="
              width: 44px;
              height: 44px;
              border-radius: 12px;
              background: rgba(16, 185, 129, 0.1);
              color: #059669;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            "
          >
            <span class="material-symbols-outlined" style="font-size: 24px;">volunteer_activism</span>
          </div>
          <div style="flex: 1;">
            <strong style="display: block; font-size: 0.95rem; color: #1e293b; margin-bottom: 0.15rem;">
              Voluntario General (Por amor al arte)
            </strong>
            <span style="display: block; font-size: 0.8125rem; color: #64748b; line-height: 1.35;">
              Participa en rescates, eventos, pláticas y campañas sin requisito de horas escolares.
            </span>
          </div>
          <span class="material-symbols-outlined" style="color: #94a3b8; font-size: 20px;">arrow_forward</span>
        </button>
      </div>
    } @else {
      <!-- PASO B: Formulario de credenciales con validación estricta -->
      <div class="auth-form-animated-wrapper" style="animation: fadeInScale 0.3s ease-out;">
        <!-- Indicador de modalidad elegida (para cambiar regresa antes y elige de nuevo) -->
        <div class="auth-selected-type-badge">
          <div class="type-badge-left">
            <span class="material-symbols-outlined type-badge-icon">
              {{ userType === 'SS' ? 'school' : 'volunteer_activism' }}
            </span>
            <div class="type-badge-texts">
              <span class="type-badge-caption">Modalidad elegida</span>
              <strong class="type-badge-name">
                {{ userType === 'SS' ? 'Servicio Social (480 horas)' : 'Voluntariado General' }}
              </strong>
            </div>
          </div>

          <button
            type="button"
            class="btn-back-to-types"
            (click)="backToStepA()"
            title="Regresar y elegir otra modalidad"
          >
            <span class="material-symbols-outlined text-sm">arrow_back</span>
            <span>Cambiar tipo</span>
          </button>
        </div>

        <form
          #stepBForm
          class="auth-form"
          id="register-form"
          (ngSubmit)="onSubmit()"
          (keydown)="handleFormKeyDown($event)"
          novalidate
        >
          <!-- Campo: Correo electrónico adaptado -->
          <div class="auth-field-group">
            <label for="reg-email" class="auth-field-label">
              <span>{{ userType === 'VG' ? 'Correo electrónico personal' : 'Correo electrónico institucional' }} <span class="text-required">*</span></span>
            </label>
            <div class="custom-input-wrapper">
              <span class="material-symbols-outlined custom-input-icon" aria-hidden="true">
                alternate_email
              </span>
              <input
                #emailInput
                id="reg-email"
                name="email"
                type="email"
                required
                class="custom-input"
                [class.input-invalid]="invalidFields['email']"
                [(ngModel)]="email"
                (ngModelChange)="clearFieldError('email')"
                [placeholder]="
                  userType === 'VG' ? 'tu.correo@gmail.com' : 'tu.nombre@alumnos.uaq.edu.mx'
                "
                autocomplete="email"
              />
            </div>
            @if (invalidFields['email']) {
              <span class="field-error-text">⚠️ {{ invalidFields['email'] }}</span>
            } @else {
              <span class="auth-field-hint">
                {{
                  userType === 'VG'
                    ? 'Usa tu correo personal para recibir notificaciones de eventos.'
                    : 'Usa tu correo de la universidad para vincular tu expediente de 480 horas.'
                }}
              </span>
            }
          </div>

          <!-- Campo: Contraseña (mínimo 8 caracteres) -->
          <div class="auth-field-group">
            <div class="auth-field-header-row">
              <label for="reg-password" class="auth-field-label">
                <span>Contraseña <span class="text-required">*</span></span>
              </label>
              <span
                style="font-size: 11px; font-weight: 700;"
                [style.color]="password.length >= 8 ? '#15803d' : '#64748b'"
              >
                {{ password.length }}/8 caracteres mín.
              </span>
            </div>
            <div class="custom-input-wrapper">
              <span class="material-symbols-outlined custom-input-icon" aria-hidden="true">
                lock
              </span>
              <input
                id="reg-password"
                name="password"
                required
                minlength="8"
                [type]="showPassword ? 'text' : 'password'"
                class="custom-input has-toggle"
                [class.input-invalid]="invalidFields['password']"
                [(ngModel)]="password"
                (ngModelChange)="clearFieldError('password')"
                placeholder="Mínimo 8 caracteres obligatorios"
                autocomplete="new-password"
              />
              <button
                type="button"
                class="custom-input-toggle-btn"
                (click)="showPassword = !showPassword"
                [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              >
                <span class="material-symbols-outlined text-lg">
                  {{ showPassword ? 'visibility_off' : 'visibility' }}
                </span>
              </button>
            </div>
            @if (invalidFields['password']) {
              <span class="field-error-text">⚠️ {{ invalidFields['password'] }}</span>
            }
          </div>

          <!-- Campo: Confirmar Contraseña -->
          <div class="auth-field-group">
            <div class="auth-field-header-row">
              <label for="reg-confirm-password" class="auth-field-label">
                <span>Confirmar Contraseña <span class="text-required">*</span></span>
              </label>
              @if (confirmPassword.length > 0) {
                <span
                  id="pwd-match-indicator"
                  class="auth-match-indicator"
                  [class.matching]="password.length >= 8 && password === confirmPassword"
                  [class.mismatch]="password !== confirmPassword || password.length < 8"
                >
                  <span class="material-symbols-outlined text-xs">
                    {{ password.length >= 8 && password === confirmPassword ? 'check_circle' : 'cancel' }}
                  </span>
                  <span>
                    {{
                      password !== confirmPassword
                        ? 'No coinciden'
                        : password.length < 8
                          ? 'Faltan caracteres (mín. 8)'
                          : 'Coinciden (8+ caracteres)'
                    }}
                  </span>
                </span>
              }
            </div>
            <div class="custom-input-wrapper">
              <span class="material-symbols-outlined custom-input-icon" aria-hidden="true">
                lock_reset
              </span>
              <input
                id="reg-confirm-password"
                name="confirmPassword"
                required
                [type]="showPassword ? 'text' : 'password'"
                class="custom-input has-toggle"
                [class.input-invalid]="invalidFields['confirmPassword']"
                [(ngModel)]="confirmPassword"
                (ngModelChange)="clearFieldError('confirmPassword')"
                placeholder="Repite tu contraseña"
                autocomplete="new-password"
              />
            </div>
            @if (invalidFields['confirmPassword']) {
              <span class="field-error-text">⚠️ {{ invalidFields['confirmPassword'] }}</span>
            }
          </div>

          <div class="auth-submit-wrapper">
            <button
              id="reg-submit-btn"
              type="submit"
              class="btn-auth-submit btn-primary-gradient group"
            >
              <span>Continuar a Fase 1</span>
              <span class="material-symbols-outlined text-lg auth-arrow-icon">
                arrow_forward
              </span>
            </button>
          </div>
        </form>
      </div>
    }

    <!-- Pie de Tarjeta con Enlace a Login -->
    <div class="auth-card-footer">
      <p class="auth-footer-text">
        ¿Ya tienes una cuenta registrada?
        <a routerLink="/auth/login" class="auth-link-login">
          Iniciar sesión
        </a>
      </p>
    </div>
  </div>
</div>